import { isInPortrait } from '@tmsw/powerups.utils.screen-info';
import { StoreSlice } from '../types';

export declare interface IGlobalsSlice {
  viewport: { width: number, height: number }
  inPortrait: boolean;
  isInterrupterEnabled: boolean;
  isDisclaimerFirstVisited: boolean | null;
  documentVisibilityState: string|null;
  orientationFetched: boolean;
  captureLockOrientation: boolean;
  setViewport: (v: {width: number, height: number}) => void;
  setInPortrait: (v: boolean) => void;
  setIsInterrupterEnabled: (v: boolean) => void;
  setDocumentVisibilityState: (v: string) => void;
  setOrientationFetched: (v: boolean) => void;
  setCaptureLockOrientation: (v: boolean) => void;
  setIsDisclaimerFirstVisited: (v: boolean) => void;
}

const createGlobalsSlice: StoreSlice<IGlobalsSlice> = (set) => ({
  viewport: { width: window.innerWidth, height: window.innerHeight },
  inPortrait: isInPortrait(),
  isInterrupterEnabled: false,
  documentVisibilityState: null,
  orientationFetched: false,
  captureLockOrientation: false,
  isDisclaimerFirstVisited: true,
  setViewport: (v) => set((state) => { state.viewport = v; }),
  setInPortrait: (v) => set((state) => { state.inPortrait = v; }),
  setIsInterrupterEnabled: (v: boolean) =>
  set((state) => {
    if (v === state.isInterrupterEnabled) return;
    state.isInterrupterEnabled = v;
  }),
  setDocumentVisibilityState: (v) => set((state) => { state.documentVisibilityState = v; }),
  setOrientationFetched: (v) => set((state) => { state.orientationFetched = v; }),
  setCaptureLockOrientation: (v) => set((state) => { state.captureLockOrientation = v; }),
  setIsDisclaimerFirstVisited: (v: boolean) =>
  set((state) => {
    state.isDisclaimerFirstVisited = v;
  }),
});

export default createGlobalsSlice;
